export const MAX_CONTAINER = {
    desktop: '664px'
}
export const POST_API_COUNTER = process.env.NEXT_PUBLIC_POST_COUNTER
export const HEADER_ID = '#mainHeader'
export const HTML_CONTENT_ID = '#mainContent'
export const RD_STATION_FORM_UA = 'UA-53687336-1'
export const TABLET_WIDTH = 1200
export const RD_STATION_FORM_ID =
    '04-09-2025-rdstation-banner-jota-materia-formulario-lead-marketing-none-92d801eadf277eb39536'
export const FORM_TAG_ID =
    'conversion-form-04-09-2025-rdstation-banner-jota-materia-formulario-lead-marketing-none'
export const FORM_SUBMITTED_EVENT = 'form_submitted_successful'
